import { RemoveCategory } from '../index'

export default function HandleRemoveCategoryFunc(selectedCategoryId: string) {
  return RemoveCategory(selectedCategoryId)
}
